import React from 'react';
import styled from 'styled-components';
import CarouselMap from '@app/DashboardComponents/ListingViewCarousel/CarouselMap';

const ListingViewAsset = ({
  asset,
}: {
  asset?: {
    type: 'image' | 'map' | 'virtualTour';
    url?: string;
    display?: boolean;
    address?: string;
    latlng?: {
      lat: number;
      lng: number;
    };
  };
}) => (
  <>
    {asset?.type === 'image' && (
      <ListingViewAssetContainer>
        <ListingViewImage
          src={asset.url}
          isZoom={!asset.display}
          className={!asset.display ? 'zoom' : undefined}
        />
      </ListingViewAssetContainer>
    )}

    {asset?.type === 'map' && (
      <CarouselMap
        address={asset.address!}
        interactive={asset.display}
        coordinates={asset.latlng}
      />
    )}

    {asset?.type === 'virtualTour' && (
      <ListingViewAssetContainer>
        <ListingViewIframe
          src={asset.url}
          allowFullScreen
          className={!asset.display ? 'no-mouse-events' : undefined}
          allow="accelerometer; gyroscope; xr-spatial-tracking"
          sandbox={
            !asset.display ? undefined : 'allow-scripts allow-same-origin'
          }
        />
      </ListingViewAssetContainer>
    )}
  </>
);

export default ListingViewAsset;

const ListingViewAssetContainer = styled.div.attrs({
  className: 'listing-view-asset',
})`
  position: relative;
  height: 100%;
  width: 100%;
`;

const ListingViewImage = styled.img<{
  isZoom: boolean;
}>`
  height: 100%;
  width: ${props => (props.isZoom ? '100%' : 'auto')};
  ${props => (props.isZoom ? 'object-fit: cover' : 'display: block')};
`;

const ListingViewIframe = styled.iframe.attrs({
  frameBorder: 0,
})`
  width: 100%;
  height: 100%;
  border: 0;
`;
